/* eslint-disable react/jsx-no-undef */
import * as React from "react";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { FGCustomPanel, IDataTableColumn, Loading } from "nsitools-react";
import { ETLCodes } from "../../../../locales";
import { SmallFormGenerator, SRSHCustomSelector } from "../../../../components";
import { BreedApi, BreedGridDto, BreedSearch, ClubApi, SaveClubAllowedBreedsDto } from "../../../../api";
import { useGlobalData } from "../../../../contexts";
import { useParams } from "react-router";
import { ERoutes } from "../../../../ERoutes";
import { Link } from "react-router-dom";

export interface IClubAllowedBreedsPageProps {}

export const ClubAllowedBreedsPage: React.FunctionComponent<IClubAllowedBreedsPageProps> = (props) => {
  const clubApi = useApiService(ClubApi);
  const breedApi = useApiService(BreedApi);
  const { id, state } = useParams<{ id: string; state: string }>();
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();

  const { data, loading, saveItem, saving } = useCrudApi<SaveClubAllowedBreedsDto>(
    {
      getApiFn: () => clubApi.getLinkedBreedsIds(+id),
      saveApiFn: (d) => clubApi.saveLinkedBreeds(d),
      onSavedRoute: (d) => `${ERoutes.kennel}/${+id}/breeds/edit`,
    },
    [id]
  );

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.BreedGroupLabel),
        computed: true,
        disableSorting: true,
        autoFitContent: true,
        fieldName: "breedGroupLabel",
        render: (row: BreedGridDto) => (
          <Link target="_blank" to={`${ERoutes.breedGroups}/${row.breedGroupId}/detail/view`}>
            {row.breedGroupNumber}. {row.breedGroupLabel}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
        render: (item: BreedGridDto) => (
          <Link target="_blank" to={`${ERoutes.breeds}/${item.breedId}/detail/view`}>
            {item.name}
          </Link>
        ),
      },
    ],
    [t]
  );

  const searchFunction = React.useCallback(
    (sObj) => breedApi.baseSearch(BreedSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [breedApi, currentLanguage.languageId]
  );

  const searchIdsFunction = React.useCallback(
    (sObj) => breedApi.getIds(BreedSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [breedApi, currentLanguage.languageId]
  );

  return (
    <Loading isLoading={loading}>
      <SmallFormGenerator
        initialValues={data}
        onSubmit={saveItem}
        editMode={state === "edit"}
        loading={loading}
        saving={saving}
      >
        <FGCustomPanel>
          {(ctx) => (
            <SRSHCustomSelector
              linkedIds={ctx.formik.values.breedIds}
              columns={columns}
              onLinkedIdsChanged={(ids) => ctx.formik.setFieldValue("breedIds", ids)}
              idField="breedId"
              searchFunction={searchFunction}
              searchIdsFunc={searchIdsFunction}
              editMode={state === "edit"}
            />
          )}
        </FGCustomPanel>
      </SmallFormGenerator>
    </Loading>
  );
};
